import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import NewSlideIcon from '~/assets/icons/new_slide.svg';
import NewChapterIcon from '~/assets/icons/new_chapter.svg';

export const NewSlideIconForButton = styled(NewSlideIcon)``;
export const NewChapterIconForButton = styled(NewChapterIcon)`
  width: 16px;
  margin-left: 3px;
`;

const PopupContainer = styled.div`
  position: absolute;
  background-color: #ffffff;
  border: 1px solid #ccc;
  width: 222px;

  box-shadow: 0px 8px 9px 0px #00000036;
  box-shadow: 0px 30px 30px 0px #00000008;
  box-shadow: 0px -2px 4px 0px #0000000d;

  padding: 5px 0px 0px 0px;
  gap: 0px;
  border-radius: 5px;
  opacity: 0px;

  z-index: 1000;
  flex-direction: column;
  display: flex;
  margin-top: 10px;
  margin-left: -20px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  margin: 3px;
  padding: 7px;
  background-color: #fff;

  font-family: Raleway;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  white-space: nowrap;

  svg {
    margin-right: 10px;
  }

  &:hover {
    background-color: #f5f5f5;
  }
`;

interface PopupMenuProps {
  isOpen: boolean;
  anchorElement: HTMLElement | null;
  onClose: () => void;
  onNewSlide: () => void;
  onNewChapter: () => void;
}

const PopupMenuCreate: React.FC<PopupMenuProps> = ({
  isOpen,
  anchorElement,
  onClose,
  onNewSlide,
  onNewChapter
}) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (anchorElement) {
      setPosition({
        top: 52,
        left: 28
      });
    }
  }, [anchorElement]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        anchorElement &&
        !anchorElement.contains(event.target as Node) &&
        !(event.target as HTMLElement).closest('.popup-container')
      ) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, anchorElement, onClose]);

  if (!isOpen || !anchorElement) return null;

  const createNewSlide = () => {
    onClose();
    onNewSlide();
  };

  const createNewChapter = () => {
    onClose();
    onNewChapter();
  };

  return ReactDOM.createPortal(
    <PopupContainer
      className="popup-container"
      style={{ top: position.top, left: position.left }}
    >
      <Button onClick={createNewSlide}>
        <NewSlideIconForButton /> New slide
      </Button>
      <Button onClick={createNewChapter}>
        <NewChapterIconForButton /> New chapter
      </Button>
    </PopupContainer>,
    document.body
  );
};

export default PopupMenuCreate;
